import { useCurrentRole } from "@/domains/auth";
import { ManagerDashboard } from "@/domains/dashboard/components/managerDashboard";
import { PartnerDashboard } from "@/domains/dashboard/components/partnerDashboard";
import { RequesterDashboard } from "@/domains/dashboard/components/requesterDashboard";

export function DashboardPage(): React.JSX.Element {
  const role = useCurrentRole();
  if (role === "requester") return <RequesterDashboard />;
  if (role === "partner") return <PartnerDashboard />;
  return <ManagerDashboard />;
}
